import styled from 'styled-components';

export const SearchForm = styled.form`
    display: flex;
    margin-left: auto;
`;